(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["catalogue-focus-controller"] && !Shopify.designMode) return;
  try {
    class CatalogueFocus extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.config = JSON.parse(this.querySelector('[data-focus-config]').textContent);
      this.storageKey = `rare-objects-in-focus-v${this.config.version}`;
      this.onPageShow = (event) => { if (event.persisted) this.rotate(); };
      window.addEventListener('pageshow', this.onPageShow);
      this.rotate();
    }

    disconnectedCallback() {
      window.removeEventListener('pageshow', this.onPageShow);
      this.abort?.abort();
      this.initialized = false;
    }

    shuffle(items) {
      const result = [...items];
      for (let i = result.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [result[i], result[j]] = [result[j], result[i]];
      }
      return result;
    }

    readState() {
      try {
        const state = JSON.parse(localStorage.getItem(this.storageKey));
        if (state && Array.isArray(state.groups) && state.pairs && typeof state.pairs === 'object' && !Array.isArray(state.pairs)) return state;
      } catch {}
      return this.memoryState || { groups: [], pairs: {}, lastGroup: this.dataset.focusGroup || 'thething' };
    }

    saveState(state) {
      this.memoryState = state;
      try { localStorage.setItem(this.storageKey, JSON.stringify(state)); } catch {}
    }

    nextGroup(state) {
      const ids = this.config.groups.map((group) => group.id);
      state.groups = [...new Set(state.groups)].filter((id) => ids.includes(id));
      if (!state.groups.length) state.groups = this.shuffle(ids);
      const last = state.lastGroup || this.dataset.focusGroup;
      const index = state.groups.findIndex((id) => id !== last && id !== this.dataset.focusGroup);
      const id = state.groups.splice(index < 0 ? 0 : index, 1)[0];
      return this.config.groups.find((group) => group.id === id);
    }

    nextPair(group, state) {
      const count = group.media.length * group.paper.length;
      let remaining = Array.isArray(state.pairs[group.id]) ? state.pairs[group.id].filter((n) => Number.isInteger(n) && n >= 0 && n < count) : [];
      if (!remaining.length) remaining = this.shuffle(Array.from({ length: count }, (_, i) => i));
      const index = remaining.shift();
      state.pairs[group.id] = remaining;
      return [group.media[Math.floor(index / group.paper.length)], group.paper[index % group.paper.length]];
    }

    interpolate(template, values) {
      return template.replace(/\[\[(\w+)\]\]/g, (_, key) => values[key] ?? '');
    }

    async product(entry) {
      if (!this.products.has(entry.handle)) {
        const url = `${this.config.root}products/${encodeURIComponent(entry.handle)}.js`;
        this.products.set(entry.handle, fetch(url, { signal: this.abort.signal, headers: { Accept: 'application/json' } })
          .then((response) => { if (!response.ok) throw new Error('Product unavailable'); return response.json(); })
          .then((product) => {
            if (product.handle !== entry.handle || !product.available || !product.featured_image || !Number.isFinite(product.price)) throw new Error('Product unavailable');
            return product;
          }));
      }
      return this.products.get(entry.handle);
    }

    imageSource(source, width) {
      const url = new URL(source, location.origin);
      if (url.protocol !== 'https:') throw new Error('Image unavailable');
      url.searchParams.set('width', width);
      return url.href;
    }

    async prepareImage(product, index) {
      const current = this.querySelectorAll('.catalogue-exhibit__object img')[index];
      if (!current) throw new Error('Image frame unavailable');
      const img = current.cloneNode(false);
      const widths = index === 0 ? [320, 480, 640, 800, 1000] : [240, 360, 480, 650];
      img.alt = product.media?.find((media) => media.media_type === 'image')?.alt || product.title;
      img.removeAttribute('width');
      img.removeAttribute('height');
      img.srcset = widths.map((width) => `${this.imageSource(product.featured_image, width)} ${width}w`).join(', ');
      img.src = this.imageSource(product.featured_image, widths[widths.length - 1]);
      await img.decode();
      img.width = img.naturalWidth;
      img.height = img.naturalHeight;
      return img;
    }

    renderPair(group, entries, products, images) {
      const strings = this.config.strings;
      const kind = entries[0].kind || group.kind;
      const heading = kind === 'film' ? (entries[0].caption.includes('VHS') ? 'tape_heading' : 'disc_heading') : `${kind}_heading`;
      const money = new Intl.NumberFormat(this.config.locale, { style: 'currency', currency: this.config.currency });
      const productLinks = this.querySelectorAll('.catalogue-editorial__item');
      const figures = this.querySelectorAll('.catalogue-exhibit__object');
      for (let i = 0; i < 2; i++) {
        const product = products[i];
        const url = `${this.config.root}products/${encodeURIComponent(product.handle)}`;
        const imageLink = figures[i].querySelector('a');
        imageLink.href = url;
        imageLink.setAttribute('aria-label', product.title);
        figures[i].querySelector('img').replaceWith(images[i]);
        figures[i].querySelector('figcaption span').textContent = entries[i].caption;
        const price = money.format(product.price / 100);
        figures[i].querySelector('figcaption strong').textContent = product.price_varies ? this.interpolate(strings.from_price, { price }) : price;
        productLinks[i].href = url;
        productLinks[i].replaceChildren(document.createTextNode(`${product.title} `));
        const arrow = document.createElement('span');
        arrow.setAttribute('aria-hidden', 'true');
        arrow.textContent = '↗';
        productLinks[i].append(arrow);
      }
      this.querySelector('.catalogue-exhibit__heading>span:last-child').textContent = `${group.director} / ${group.film}`;
      this.querySelector('.catalogue-editorial>.catalogue-kicker').textContent = strings[`${kind}_kicker`];
      this.querySelector('.catalogue-editorial h2').textContent = strings[heading];
      this.querySelector('.catalogue-editorial>p').textContent = this.interpolate(strings.description, { film: group.film, media: entries[0].label, paper: entries[1].label, note: this.config.notes[entries[0].note || group.note] });
      const directorLink = this.querySelector('.catalogue-editorial>.catalogue-link');
      const search = new URL(this.config.search, location.origin);
      search.searchParams.set('q', group.director);
      search.searchParams.set('type', 'product');
      directorLink.href = group.collection ? `${this.config.root}collections/${group.collection}` : `${search.pathname}${search.search}`;
      directorLink.replaceChildren(document.createTextNode(`${this.interpolate(strings.explore, { director: group.director })} `));
      const arrow = document.createElement('span');
      arrow.setAttribute('aria-hidden', 'true');
      arrow.textContent = '→';
      directorLink.append(arrow);
      this.dataset.focusGroup = group.id;
      this.dataset.focusPair = entries.map((entry) => entry.handle).join('|');
      this.dataset.focusStatus = 'ready';
    }

    async rotate() {
      if (this.busy || !this.isConnected) return;
      this.busy = true;
      this.abort = new AbortController();
      this.products = new Map();
      const timeout = setTimeout(() => this.abort.abort(), 12000);
      const state = this.readState();
      try {
        for (let attempt = 0; attempt < Math.min(8, this.config.groups.length); attempt++) {
          const group = this.nextGroup(state);
          const entries = this.nextPair(group, state);
          try {
            const products = await Promise.all(entries.map((entry) => this.product(entry)));
            const images = await Promise.all(products.map((product, index) => this.prepareImage(product, index)));
            if (!this.isConnected || this.abort.signal.aborted || this.contains(document.activeElement)) return;
            this.renderPair(group, entries, products, images);
            state.lastGroup = group.id;
            this.saveState(state);
            return;
          } catch {
            if (this.abort.signal.aborted) break;
          }
        }
        this.dataset.focusStatus = 'fallback';
      } finally {
        clearTimeout(timeout);
        this.busy = false;
      }
    }
  }
  if (!customElements.get('catalogue-focus')) customElements.define('catalogue-focus', CatalogueFocus);
  } catch(e) { console.error(e); }
})();

})();
